import { PaymentStatus } from '../EventBooking';

export interface ChangeBookingPaymentStatusRequest {
  targetStatus: PaymentStatus;
  comment?: string;
  paymentExpectedBy?: string;
}
